import React, { useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
// Sửa dòng này: Import QRCodeSVG thay vì QRCode mặc định
import { QRCodeSVG } from 'qrcode.react'; 
import ReactToPrint from 'react-to-print';

const QRCodeModal = ({ isOpen, handleClose, assetCode, publicUrl }) => {
    const componentRef = useRef();

    return (
        <Modal show={isOpen} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Mã QR Tài sản - {assetCode}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
                <div ref={componentRef} style={{ padding: '20px', backgroundColor: 'white' }}>
                    <div style={{ marginBottom: '10px', fontWeight: 'bold', fontSize: '18px' }}>
                        Tài sản: {assetCode}
                    </div>
                    {publicUrl ? (
                        /* Sửa component QRCode thành QRCodeSVG */
                        <QRCodeSVG 
                            value={publicUrl} 
                            size={200}
                            level={"H"}
                            includeMargin={true}
                        />
                    ) : (
                        <div>Không có dữ liệu URL để tạo mã QR</div>
                    )}
                    <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                        Quét mã này để xem chi tiết tài sản
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <ReactToPrint
                    trigger={() => (
                        <Button variant="primary">
                            <i className="feather icon-printer mr-2"></i> In Mã QR
                        </Button>
                    )}
                    content={() => componentRef.current}
                    // Thêm style này để đảm bảo khi in mã QR không bị mất màu hoặc vỡ khung
                    pageStyle="@page { size: auto; margin: 10mm; } @media print { body { -webkit-print-color-adjust: exact; } }"
                />
                <Button variant="secondary" onClick={handleClose}>
                    Đóng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default QRCodeModal;